export default __webpack_public_path__ + "static/media/Lumia.2ae1a597.png";